import React, { useState, createContext, useMemo } from 'react';
import logComponent from '../common/logComponent';

// create context
const CardMoodSnapshotContext = createContext(null);
const timeRanges = [
  'Past 7 days',
  'Past 30 days'
];

// declare provider component
const CardMoodSnapshotProvider = ({ children }) => {
  const [moodSnapshot, setMoodSnapshot] = useState(null);
  const [moodSnapshotLoading, setMoodSnapshotLoading] = useState(null);
  const [moodSnapshotError, setMoodSnapshotError] = useState(null);

  const setTheMoodSnapshot = (moodSnapshot) => {
    if (logComponent('CardMoodSnapshotContext')) { console.debug('CardMoodSnapshotContext setTheMoodSnapshot'); }
    let newMoodSnapshot = moodSnapshot ? [ ...moodSnapshot ] : null;
    setMoodSnapshot(newMoodSnapshot);
  }

  const setTheMoodSnapshotLoading = (moodSnapshotLoading) => {
    if (logComponent('CardMoodSnapshotContext')) { console.debug('CardMoodSnapshotContext setTheMoodSnapshotLoading'); }
    let newMoodSnapshotLoading = moodSnapshotLoading;
    setMoodSnapshotLoading(newMoodSnapshotLoading);
  }

  const setTheMoodSnapshotError = (moodSnapshotError) => {
    if (logComponent('CardMoodSnapshotContext')) { console.debug('CardMoodSnapshotContext setTheMoodSnapshotError'); }
    let newMoodSnapshotError = moodSnapshotError;
    setMoodSnapshotError(newMoodSnapshotError);
  }

  const cardState = useMemo(() => ({
    moodSnapshot,
    moodSnapshotLoading,
    moodSnapshotError,
    setMoodSnapshot: setTheMoodSnapshot,
    setMoodSnapshotLoading: setTheMoodSnapshotLoading,
    setMoodSnapshotError: setTheMoodSnapshotError
  }), [
    moodSnapshot,
    moodSnapshotLoading,
    moodSnapshotError
]);

  return (
    <CardMoodSnapshotContext.Provider value={ cardState }>
      {children}
    </CardMoodSnapshotContext.Provider>
  );
}

// export provider and context
export { CardMoodSnapshotContext, CardMoodSnapshotProvider };